import { render, staticRenderFns } from "./AddTutorial.vue?vue&type=template&id=0f2c5f66&"
import script from "./AddTutorial.vue?vue&type=script&lang=js&"
export * from "./AddTutorial.vue?vue&type=script&lang=js&"
import style0 from "./AddTutorial.vue?vue&type=style&index=0&id=0f2c5f66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports